export default __webpack_public_path__ + "static/media/coffee.06d317df.4ac2db3e.svg";